import * as React from "react";

export function TrustedOrganizations() {
  return (
    <section className="px-0 py-12 mt-12 bg-blue-50 border-t border-solid border-t-gray-200">
      <div className="px-4 py-0 mx-auto my-0 text-center max-w-[1200px]">
        <h2 className="mx-0 mt-0 mb-8 text-2xl font-semibold text-zinc-700">
          Trusted by Leading Organizations
        </h2>
        <div className="grid gap-8 justify-items-center items-center grid-cols-[repeat(auto-fit,minmax(200px,1fr))] max-sm:gap-6 max-sm:grid-cols-[repeat(2,1fr)]">
          <div className="flex justify-center items-center p-6 h-20 bg-white rounded-xl border border-gray-200 border-solid transition-all duration-[0.2s] ease-[ease] hover:shadow-md">
            <img
              src="https://images.pexels.com/photos/159490/yale-university-landscape-universities-schools-159490.jpeg"
              alt="Sumner County Schools"
              className="object-contain max-h-10 max-w-[120px]"
            />
          </div>
          <div className="flex justify-center items-center p-4 bg-white rounded-xl border border-gray-200 border-solid transition-all duration-[0.2s] ease-[ease] hover:shadow-md">
            <div className="text-base font-semibold text-zinc-700">
              Tennessee Department of Labor
            </div>
          </div>
          <div className="flex justify-center items-center p-4 bg-white rounded-xl border border-gray-200 border-solid transition-all duration-[0.2s] ease-[ease] hover:shadow-md">
            <div className="text-base font-semibold text-zinc-700">
              Volunteer State College
            </div>
          </div>
          <div className="flex justify-center items-center p-4 bg-white rounded-xl border border-gray-200 border-solid transition-all duration-[0.2s] ease-[ease] hover:shadow-md">
            <div className="text-base font-semibold text-zinc-700">
              Middle Tennessee State University
            </div>
          </div>
          <div className="flex justify-center items-center p-4 bg-white rounded-xl border border-gray-200 border-solid transition-all duration-[0.2s] ease-[ease] hover:shadow-md">
            <div className="text-base font-semibold text-zinc-700">
              Sumner County Chamber
            </div>
          </div>
          <div className="flex justify-center items-center p-4 bg-white rounded-xl border border-gray-200 border-solid transition-all duration-[0.2s] ease-[ease] hover:shadow-md">
            <div className="text-base font-semibold text-zinc-700">
              Tennessee Career Centers
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
